import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function TrackPageView() {
  const location = useLocation();

  useEffect(() => {
    // 페이지 방문 추적
    // if (window.wcs) {
    //   window.wcs.inflow();
    //   window.wcs_do();
    // }

    // 전환 이벤트
    if (
      location.pathname === "/complete-request" ||
      location.pathname === "/cselling-complete-request"
    ) {
      const _conv = {};
      _conv.type = "lead"; 
      if (window.wcs && window.wcs.trans) {
        window.wcs.trans(_conv);
      }
    }
  }, [location.pathname]);

  return null;
}

export default TrackPageView;
